import { supabase } from '../lib/supabase';
import { Player } from '../types/database';

export const playersService = {
  /**
   * Get all active players
   */
  async getPlayers(): Promise<Player[]> {
    try {
      const { data, error } = await supabase
        .from('players')
        .select('*')
        .eq('is_active', true)
        .order('full_name');

      if (error) {
        console.error('Error fetching players:', error);
        throw error;
      }

      return data || [];
    } catch (error) {
      console.error('Error in getPlayers:', error);
      throw error;
    }
  },

  /**
   * Get a specific player by ID
   */
  async getPlayerById(playerId: string): Promise<Player | null> {
    try {
      const { data, error } = await supabase
        .from('players')
        .select('*')
        .eq('id', playerId)
        .eq('is_active', true)
        .single();

      if (error) {
        console.error('Error fetching player:', error);
        return null;
      }

      return data;
    } catch (error) {
      console.error('Error in getPlayerById:', error);
      return null;
    }
  },

  /**
   * Create a new player
   */
  async createPlayer(playerData: Omit<Player, 'id' | 'created_at' | 'updated_at'>): Promise<Player> {
    try {
      const { data, error } = await supabase
        .from('players')
        .insert([playerData])
        .select()
        .single();

      if (error) {
        console.error('Error creating player:', error);
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Error in createPlayer:', error);
      throw error;
    }
  },

  /**
   * Update a player
   */
  async updatePlayer(playerId: string, updates: Partial<Player>): Promise<Player> {
    try {
      const { data, error } = await supabase
        .from('players')
        .update(updates)
        .eq('id', playerId)
        .select()
        .single();

      if (error) {
        console.error('Error updating player:', error);
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Error in updatePlayer:', error);
      throw error;
    }
  },

  /**
   * Soft delete a player (set is_active to false)
   */
  async deletePlayer(playerId: string): Promise<void> {
    try {
      const { error } = await supabase
        .from('players')
        .update({ is_active: false })
        .eq('id', playerId);

      if (error) {
        console.error('Error deleting player:', error);
        throw error;
      }
    } catch (error) {
      console.error('Error in deletePlayer:', error);
      throw error;
    }
  },

  /**
   * Search players by name
   */
  async searchPlayers(searchTerm: string): Promise<Player[]> {
    try {
      const { data, error } = await supabase
        .from('players')
        .select('*')
        .eq('is_active', true)
        .ilike('full_name', `%${searchTerm}%`)
        .order('full_name');

      if (error) {
        console.error('Error searching players:', error);
        throw error;
      }

      return data || [];
    } catch (error) {
      console.error('Error in searchPlayers:', error);
      throw error;
    }
  },
};




